import axios from 'axios'

export default {
  getEnrollments ({ commit }, params) {
    commit('getEnrollmentsRequest')
    let url = '/api/enrollment/'
    params.limit = 0

    return axios
      .get(url, { params })
        .then((response) => {
          commit('getEnrollmentsSuccess', response.data)
          return response.data
        })
        .catch((error) => {
          commit('getEnrollmentsFailure', error)
          throw error
        })
  },
  getEnrollmentById ({ commit }, { id }) {
    commit('getEnrollmentByIdRequest')
    let url = `/api/enrollment/${id}/`
    return axios
      .get(url)
        .then((response) => {
          commit('getEnrollmentByIdSuccess', response.data)
          return response.data
        })
        .catch((error) => {
          commit('getEnrollmentByIdFailure', error)
          throw error
        })
  },
  getEnrollmentBySchoolYear ({ commit }, { school_year }) {
    commit('getEnrollmentBySchoolYearRequest')
    let url = `/api/enrollment/?school_year=${school_year}`
    return axios
      .get(url)
        .then((response) => {
          commit('getEnrollmentBySchoolYearSuccess', response.data)
          return response.data
        })
        .catch((error) => {
          commit('getEnrollmentBySchoolYearFailure', error)
          throw error
        })
  },
  getEnrollmentsByStudent ({ commit }, { student }) {
    commit('getEnrollmentsByStudentRequest')
    let url = `/api/enrollment/?student=${student}&limit=0`
    return axios
      .get(url)
        .then((response) => {
          commit('getEnrollmentsByStudentSuccess', response.data)
          return response.data
        })
        .catch((error) => {
          commit('getEnrollmentsByStudentFailure', error)
          throw error
        })
  },
  getStudentByStudentNo ({ commit }, { student_number }) {
    commit('getStudentByStudentNoRequest')
    let url = `/api/enrollment/?student_number=${student_number}`
    return axios
      .get(url)
        .then(function (response) {
          commit('getStudentByStudentNoSuccess', response.data)
          return response.data
        })
        .catch(function (error) {
          commit('getStudentByStudentNoFailure', error)
          throw error
        })
  },
  createEnrollment ({ commit }, enrollment) {
    commit('createEnrollmentRequest')
    let url = '/api/enrollment/'
    return axios
      .post(url, enrollment)
      .then(function (response) {
        commit('createEnrollmentSuccess', response.data)
        return response.data.data
      })
      .catch(function (error) {
        commit('createEnrollmentFailure', error.response.data)
        throw error.response.data
      })
  },
  updateEnrollment ({ commit }, enrollment) {
    commit('updateEnrollmentRequest')
    let url = `/api/enrollment/${enrollment.id}/`
    return axios
      .patch(url, enrollment)
      .then((response) => {
        commit('updateEnrollmentSuccess', response.data)
        return response.data.data
      })
      .catch((error) => {
        commit('updateEnrollmentFailure', error.response.data)
        throw error.response.data
      })
  },
}
